/**
 * Utility functions to detect if the app is running in Electron environment
 */

/**
 * Checks if the app is currently running in Electron
 * @returns {boolean} True if running in Electron, false otherwise
 */
export const isElectron = () => {
  // Check multiple indicators to ensure we're in Electron
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('electron') !== -1) {
    return true;
  }

  // Check for window.electronAPI (exposed in preload script)
  if (typeof window !== 'undefined' && window.electronAPI) {
    return true;
  }

  // Check for process object (Node.js in renderer)
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  return false;
};

/**
 * Gets the current timezone for API calls
 * @returns {string} Timezone offset string (e.g., "+01", "-05")
 */
export const getTimezoneOffset = () => {
  const now = new Date();
  const offset = -now.getTimezoneOffset() / 60;
  const sign = offset >= 0 ? '+' : '-';
  const absOffset = Math.abs(offset);
  return `${sign}${absOffset.toString().padStart(2, '0')}`;
};

/**
 * Checks if local notifications are supported
 * @returns {boolean} True if local notifications are supported
 */
export const isLocalNotificationSupported = () => {
  return isElectron() && typeof window !== 'undefined' && window.electronAPI && window.electronAPI.localNotifications;
};

export default {
  isElectron,
  getTimezoneOffset,
  isLocalNotificationSupported
}; 